"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NewLabel = function NewLabel() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "new-label text-xs heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "shared_components.new_label.cdc_guidelines",
    defaultMessage: "New"
  }));
};
var _default = exports.default = NewLabel;